'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalFooter = require('react-bootstrap/lib/ModalFooter');

var _ModalFooter2 = _interopRequireDefault(_ModalFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ModalFooter2.default;